export const SectionHead = ({ index, title, lead }) => (
  <div className="mb-16 md:mb-24">
    <p className="text-xs font-mono tracking-[0.2em] uppercase text-[#FF2A00] mb-6">{index} // {title}</p>
    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight font-bold uppercase text-white leading-[0.95]">{title}</h2>
    {lead && <p className="mt-8 max-w-2xl text-sm md:text-base font-mono tracking-tight text-[#8A8F98] leading-relaxed">{lead}</p>}
  </div>
);
